import { useIsActiveByName } from '../../../modules/hooks';
import useShallowEqualSelector from '../../core/useShallowEqualSelector';
import {
  MODULE_NAME, storageValueApp, storageValueDesktop, storageValueTerminal
} from './utils';

export const useIsActive = () => useIsActiveByName(MODULE_NAME);

export const isLayerApp = (store) => store?.appState?.currentLayer === storageValueApp;
export const isLayerDesktop = (store) => store?.appState?.currentLayer === storageValueDesktop;
export const isLayerTerminal = (store) => store?.appState?.currentLayer === storageValueTerminal;

export const useIsLayerApp = () => useShallowEqualSelector(isLayerApp);
export const useIsLayerDesktop = () => useShallowEqualSelector(isLayerDesktop);
export const useIsLayerTerminal = () => useShallowEqualSelector(isLayerTerminal);
